// SP版宿泊予約/レストラン予約フォームのアコーディオン開閉
$('.js-toggleForm').on('click', function () {
  $(this).toggleClass('is-open');
  $(this).next().children('.search-container').slideToggle();
  $(this).next().children('.links-container').slideToggle();
});